module.exports = __webpack_public_path__ + "static/rhs_blue_fr@2x-ff8c0d5c7b7e95468647ed7a17339eac.png";